import React from "react";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import { Box, Slider, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";

const CustomOutlinedInput = styled(OutlinedInput)`
  height: '100px';
  background: #232323;
  margin-right: 13px;
  height: 100%;
  
  .MuiOutlinedInput-input {
    padding: 6px 0 6px 14px;
    border: none;
    width: 25px !important;
    font-size: 13px;
    font-weight: 600;
    font-family: "Open Sans";
  }
    
  .MuiInputAdornment-root {
    margin: 0;
    p {
      color: #a8a8a8;
      font-size: 13px;
      font-weight: 600;
      font-family: "Open Sans";
      margin: 0;
    }
  }
`;

const CustomSlider = styled(Slider)`
  &.MuiSlider-root {
    width: 120px;
    color: #c4c4c4;
    .MuiSlider-thumb {
      color: #3f51b5;
    }
  }
`;

const SliderContainer = styled(Box)`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PercentSlider = (props) => {
  const { value, onChange } = props;

  const handleChange = (event, newValue) => {
    event.stopPropagation();
    if (onChange) onChange(newValue || 0);
  };

  const handleInputChange = (event) => {
    if (onChange) onChange(event.target.value || 0);
  };

  const CustomTooltip = (props) => {
    const useStyles = makeStyles((theme) => ({
      tooltip: {
        color: "white",
        fontSize: "12px !important",
        backgroundColor: "#5A5A5A",
        borderRadius: 3,
        fontFamily: 'Roboto',
        padding: '8px 10px'
      }
    }));
    const classes = useStyles();
    return <Tooltip classes={classes} {...props} />;
  }

  return (
    <SliderContainer>
      <CustomTooltip title="Opacity" aria-label="opacity" placement="top">
        <CustomOutlinedInput value={value} onChange={handleInputChange} endAdornment={<InputAdornment position="end">%</InputAdornment>} />
      </CustomTooltip>
      <CustomSlider value={value || 0} onChange={handleChange} />
    </SliderContainer>
  );
};

export default PercentSlider;